import * as tslib_1 from "tslib";
import { OnDestroy, OnInit, } from '@angular/core';
import { FormBuilder, Validators, } from '@angular/forms';
import { ParameterValidators, UiParameterCollectionComponent, } from '@components/shared/ui-parameter-collection/ui-parameter-collection.component';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import { JobStartStrategy, } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { ProcessRobotsGridComponent } from '@pages/process/grids';
import { MAX_NUMBER_OF_JOBS, MAX_NUMBER_OF_RESULTS, } from '@pages/shared/constants';
import { JobService, ProcessService, SessionsService, } from '@services';
import UiValidators from '@validators';
import cloneDeep from 'lodash-es/cloneDeep';
import { BehaviorSubject, of, Subject, } from 'rxjs';
import { finalize, map, switchMap, takeUntil, } from 'rxjs/operators';
var JobModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(JobModalComponent, _super);
    function JobModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.JobStartStrategy = JobStartStrategy;
        _this.model = {};
        _this.loading$ = new BehaviorSubject(false);
        _this.environmentId = 0;
        _this.maxNoOfJobs = MAX_NUMBER_OF_JOBS;
        _this._processService = _this._injector.get(ProcessService);
        _this._jobService = _this._injector.get(JobService);
        _this._sessionsService = _this._injector.get(SessionsService);
        _this._translate = _this._injector.get(TranslateService);
        _this._fb = _this._injector.get(FormBuilder);
        _this._destroyed$ = new Subject();
        _this.processSearchFactory = function (query, step, skip) {
            if (query === void 0) { query = ''; }
            if (step === void 0) { step = MAX_NUMBER_OF_RESULTS; }
            if (skip === void 0) { skip = 0; }
            return _this._processService.suggest(query, step, skip);
        };
        return _this;
    }
    Object.defineProperty(JobModalComponent.prototype, "selectedRobots", {
        get: function () {
            if (this.processRobotsGrid && this.processRobotsGrid.selectedRobots) {
                return this.processRobotsGrid.selectedRobots.map(function (robot) { return robot.id; });
            }
            return [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JobModalComponent.prototype, "isTargetSpecificRobots", {
        get: function () {
            return this.strategy === JobStartStrategy.SpecificRobots;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JobModalComponent.prototype, "isTargetJobsCount", {
        get: function () {
            return this.strategy === JobStartStrategy.JobsCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JobModalComponent.prototype, "strategy", {
        get: function () {
            return this.form && this.form.get('strategy').value;
        },
        set: function (target) {
            this.form.get('strategy').setValue(target);
            if (this._strategyRequiresRobots &&
                this.model.releaseKey) {
                this.processRobotsGrid.environmentId = this.environmentId;
            }
            this._setTargetConditionalValidation();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JobModalComponent.prototype, "isInputJobProvided", {
        get: function () {
            return this._inputJob.robot != null;
        },
        enumerable: true,
        configurable: true
    });
    JobModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.model.jobsCount = 1;
        this.model.releaseKey = '';
        // this._inputJob is used for enabling/disabling ability to select the Process
        this._inputJob = cloneDeep(this.context.data);
        var inputJob = this._inputJob;
        this.form = this._fb.group({
            releaseKey: [
                inputJob.release ?
                    [{ id: inputJob.release.id, text: inputJob.release.name }] :
                    [],
                UiValidators.required(),
            ],
            jobsCount: [this.model.jobsCount],
            strategy: [JobStartStrategy.SpecificRobots],
            arguments: [inputJob.release && inputJob.inputArguments || {}],
        }, {
            validators: function () {
                return _this._strategyRequiresRobots &&
                    _this.processRobotsGrid.selectedRobots.length === 0 ?
                    ({
                        'noRobotsSelected': true,
                    }) : null;
            },
        });
        if (inputJob.release != null) {
            // read from database the process information on inputJob
            var getRobot_1 = function (databaseProcessInfo) { return inputJob.robot != null ?
                _this._sessionsService
                    .getNonAttendedRobotInEnvironment(databaseProcessInfo.environmentId, inputJob.robot.id)
                    .pipe(map(function (s) { return ({
                    process: databaseProcessInfo,
                    sessions: s.data,
                }); })) :
                // job didn't have a robot, return an empty array
                of({ process: databaseProcessInfo, sessions: [] }); };
            this._processService
                .getInstance(inputJob.release.id)
                .pipe(switchMap(function (databaseProcessInfo) { return getRobot_1(databaseProcessInfo); }), takeUntil(this._destroyed$))
                .subscribe(function (_a) {
                var process = _a.process, sessions = _a.sessions;
                _this.process = process;
                _this.environmentId = _this.process.environmentId;
                _this.model.releaseKey = _this.process.key;
                if (inputJob.robot != null) {
                    // set environmentId on the grid, which causes the grid to load the robots
                    _this.processRobotsGrid.environmentId = _this.process.environmentId;
                    // preselect the robot on the grid IF it is still in the environment
                    if (sessions.length === 1) {
                        var robot = tslib_1.__assign({}, inputJob.robot, { sessionId: inputJob.robot.id });
                        _this.processRobotsGrid.selectedRobots = [robot];
                    }
                }
            });
        }
        this._setTargetConditionalValidation();
    };
    JobModalComponent.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
        this._destroyed$.complete();
    };
    JobModalComponent.prototype.onProcessSelected = function (event) {
        var process = event.data;
        this.process = process;
        var argumentInput = this.form.get('arguments');
        argumentInput.clearValidators();
        if (this.process.arguments) {
            argumentInput.setValidators(ParameterValidators.required(this.process.arguments.input));
        }
        argumentInput.updateValueAndValidity(argumentInput.value);
        this.model.releaseKey = process.key;
        this.environmentId = process.environmentId;
        if (this._strategyRequiresRobots) {
            this.processRobotsGrid.environmentId = this.environmentId;
        }
        this._setTargetConditionalValidation();
    };
    JobModalComponent.prototype.onSubmit = function () {
        var _this = this;
        if (!this.form.valid ||
            (!this.parameterCollectionComponent || this.parameterCollectionComponent.isOpen) ||
            this.loading$.value) {
            return;
        }
        this.loading$.next(true);
        this._jobService
            .startJobs({
            releaseKey: this.model.releaseKey,
            strategy: this.strategy,
            robotIds: this.isTargetSpecificRobots ? this.selectedRobots : [],
            jobsCount: this.isTargetSpecificRobots ? 0 : this.form.get('jobsCount').value,
            inputArguments: this.form.get('arguments').value,
        })
            .pipe(finalize(function () { return _this.loading$.next(false); }))
            .subscribe(function () {
            _this._snack.info(_this._translate.instant('job_modal_confirmation_message'));
            _this._dialogRef.close();
        });
    };
    JobModalComponent.prototype._setTargetConditionalValidation = function () {
        var jobsCountControl = this.form.get('jobsCount');
        var validators = this.isTargetSpecificRobots ?
            null :
            [Validators.required, UiValidators.range(1, MAX_NUMBER_OF_JOBS)];
        jobsCountControl.setValidators(validators);
        jobsCountControl.updateValueAndValidity();
        this.form.updateValueAndValidity();
    };
    Object.defineProperty(JobModalComponent.prototype, "_strategyRequiresRobots", {
        get: function () {
            return this.strategy === JobStartStrategy.SpecificRobots;
        },
        enumerable: true,
        configurable: true
    });
    return JobModalComponent;
}(UiModalComponent));
export { JobModalComponent };
